/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import round from 'lodash/round';
import CellCoverageIcon from './CellCoverageIcon';
import type { cellAggregateRating } from '../model/aggregate';
import { describeCoverage } from '../utils/cellCoverage';

type PropTypes = {
    cellRating: cellAggregateRating;
};

export default class CellCoverageLine extends React.PureComponent<PropTypes> {
    render() {
        const {
            cellRating: { carrier, average_rating: rating, number_of_ratings: numRating },
        } = this.props;
        return (
            <div className="cell-coverage-line-wrapper">
                <div className="cell-coverage-carrier-review">
                    <h3 aria-label={`${carrier} - ${round(rating, 1)} of 4`}>
                        <strong>{carrier}</strong>
                    </h3>{' '}
                    {`(${numRating} ${numRating === 1 ? 'review' : 'reviews'})`}
                </div>
                <div className="cell-coverage-carrier-coverage">
                    <CellCoverageIcon value={rating} size="sm" />
                    <strong>{round(rating, 1)}</strong>
                    {numRating ? ` - ${describeCoverage(rating)}` : ' - No Reviews'}
                </div>
            </div>
        );
    }
}
